export default __webpack_public_path__ + "static/media/img-private.afad6bda.jpg";